'use strict';

global.utl = require('../utils.js');
global.offset = 0;

var limit = 4;
var limitMoodborad = global.offset;
var blocksLimit = {
    'offprint_highlighted': '1',
    'offprints': '5'
};
var loaded = false;
var finish = false;
var init = true;

var self = module.exports = {
    pageOffprints: 1,
    init: function () {
        if (init == true) {
            // Ho aggiunto un controllo di esistenza per evitare errori
            // visto che le funzioni potrebbero non essere dichiarate qui
            if (typeof self.initOffprintHighlighted === 'function') self.initOffprintHighlighted();
            if (typeof self.initOffprints === 'function') self.initOffprints();
            if (typeof self.initOffprintsPagination === 'function') self.initOffprintsPagination();
            // if (typeof self.existMore === 'function') self.existMore(global.offset, 1);
        }
    },

    loaded: function() {
        loaded = true;
    },
    itemsOffprintsWidget: document.querySelector('#latests-section_offprints'),
    itemsOffprintHighlightedWidget: document.querySelector('#latests-section_offprint_highlighted'),
    templateOffprintsWidget: document.querySelector('#latests-template-offprints'),
    templateOffprintHightlightedWidget: document.querySelector('#latests-template-offprint_highlighted'),
    paginationOffprintsWidget: document.querySelector('#latests-pagination_offprints'),
    render: function (key, data, wrapper, template) {
        var blocks = [];
        data.forEach(function (widget) {
            // Assumendo che il valore sia dentro widget.widgetpreview.template
            var tipoTemplate = widget.widgetpreview.template;

            widget.widgetpreview.isCaseHistory = (tipoTemplate === 'case_history');
            widget.widgetpreview.isNews = (tipoTemplate === 'news');
            blocks.push(widget);
        });
        mustache.parse(template);
        var rendered = mustache.render(template, {
            widgets: blocks
        });
        wrapper.innerHTML = rendered;
    },
    initOffprintHighlighted: function () {
        self.loadMore('offprint_highlighted', 0, 1)
            .then(function (data) {
                console.log("Dati recuperati con successo:", data);
                self.render('offprint_highlighted', data, self.itemsOffprintHighlightedWidget, self.templateOffprintHightlightedWidget.innerHTML);
            })
            .catch(function (error) {
                // È buona norma gestire eventuali errori di rete o parsing
                console.error("Errore durante il recupero del blocco:", error);
            });
    },
    paginationOffprints: 5,
    initOffprints: function () {
        self.loadMore('offprints', 0, self.paginationOffprints)
            .then(function (data) {
                console.log("Dati recuperati con successo:", data);
                self.render('offprints', data, self.itemsOffprintsWidget, self.templateOffprintsWidget.innerHTML);
            })
            .catch(function (error) {
                // È buona norma gestire eventuali errori di rete o parsing
                console.error("Errore durante il recupero del blocco:", error);
            });
    },
    loadMore: function(block, offset, limit) {
        var url = '/rest/widgets/widgetoffprint/latests_landing/' + block + '/' + offset + ',' + limit + '/position,asc';

        // Sostituiamo $.ajax con fetch (Vanilla JS)
        return fetch(url, {
            method: 'GET'
        })
            .then(function(response) {
                // Se lo status della risposta non è 2xx, lanciamo un errore
                if (!response.ok) {
                    throw new Error('Errore di rete: ' + response.status);
                }
                // response.json() parsificherà il body e lo passerà
                // come "data" al blocco .then in initOffprintHighlighted
                return response.json();
            });
    },
    initOffprintsPagination: function () {
        var widget = self.paginationOffprintsWidget;
        if (!widget) {
            return;
        }

        var total = parseInt(widget.dataset.total, 10);
        var pagination = self.paginationOffprints;


        console.log('initOffprintsPagination', widget, total, pagination);

        if (!total || !pagination) {
            return;
        }

        var pages = Math.ceil(total / pagination);

        // Se c'è una sola pagina non mostriamo la paginazione
        if (pages <= 1) {
            widget.innerHTML = '';
            return;
        }

        var html = '<ul class="latests-pagination">';

        for (var i = 1; i <= pages; i++) {
            html += `
                <li class="${i === self.pageOffprints ? 'active' : ''}">
                    <button class="latests-pagination__button" type="button" data-page="${i}" aria-label="Pagina ${i}" aria-controls="latests-section_offprints"${i === self.pageOffprints ? ' aria-current="page"' : ''}>
                        ${i}
                    </button>
                </li>
            `;
        }

        html += '</ul>';

        widget.innerHTML = html;

        // Event delegation
        widget.addEventListener('click', function (e) {
            var button = e.target.closest('[data-page]');

            if (!button) {
                return;
            }

            var page = parseInt(button.dataset.page, 10);

            if (!page || page === self.pageOffprints) {
                return;
            }

            self.pageOffprints = page;

            self.itemsOffprintsWidget.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Svuota i risultati precedenti
            self.itemsOffprintsWidget.innerHTML = '';

            // Aggiorna classe active
            widget.querySelectorAll('[data-page]').forEach(function (btn) {
                btn.parentElement.classList.remove('active');
                btn.removeAttribute('aria-current');
            });

            button.parentElement.classList.add('active');
            button.setAttribute('aria-current', 'page');

            self.loadMore('offprints', (self.pageOffprints - 1) * self.paginationOffprints, self.paginationOffprints)
                .then(function (data) {
                    console.log("Dati recuperati con successo:", data);
                    self.render('offprints', data, self.itemsOffprintsWidget, self.templateOffprintsWidget.innerHTML);
                })
                .catch(function (error) {
                    // È buona norma gestire eventuali errori di rete o parsing
                    console.error("Errore durante il recupero del blocco:", error);
                });
        });
    },
};

self.init();
